import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';
import ProviderIcon from 'components/ProviderIcon';

import './ProvidersDetails.scss';

const b = block('providers-details');

const ProvidersDetails = ({ providers }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const ProvidersElements = useMemo(() => {
    return providers.map(({ provider, changes }) => (
      <div key={provider.provider} className={b('provider')}>
        <div className={b('header')}>
          <div className={b('header-title')}>
            <div className={b('header-icon')}>
              <ProviderIcon name={provider.provider.toLowerCase()} />
            </div>
            <span className={b('header-name')}>{provider.provider}</span>
          </div>
          <span className={b('header-text')}>{locale.became}</span>
        </div>

        <div className={b('body')}>
          <div className={b('body-left')}>
            <span className={b('body-text')}>{locale.was}:</span>
          </div>
          <div className={b('body-right')}>
            {changes?.isActive !== undefined && (
              <div className={b('changes-item')}>
                <span className={b('changes-before')}>
                  {changes.isActive.before ? locale.itemActive : locale.itemDisabled}
                </span>
                <span
                  className={b('changes-after', {
                    variant: changes.isActive.after ? 'active' : 'disabled',
                  })}>
                  {changes.isActive.after ? locale.itemActive : locale.itemDisabled}
                </span>
              </div>
            )}
            {changes?.position !== undefined && (
              <div className={b('changes-item')}>
                <span className={b('changes-before')}>
                  {locale.valuePlace.replace('<value>', changes.position.before)}
                </span>
                <span className={b('changes-after')}>
                  {locale.valuePlace.replace('<value>', changes.position.after)}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    ));
  }, [providers, locale]);

  return (
    <div className={b()}>
      <div className={b('list')}>{ProvidersElements}</div>
    </div>
  );
};

export default ProvidersDetails;
